import { MaintenanceTaskCategory } from '../maintenance-task-category';

export class MaintenanceTaskItem {
    id?: number;
    completedBy?: any;
    completedAt?: string;
    maintenanceTaskName?: string;
    maintenanceTaskId?: number;
}

export class MaintenanceTask {
    description?: string;
    id?: number;
    name?: string;
    periodNumber?: number;
    periodType?: string;
    lastCompletion?: MaintenanceTaskItem | null = null;
    maintenanceTaskCategory: MaintenanceTaskCategory;

    public get hasBeenCompleted(): boolean {
        return this.lastCompletion != null;
    }

    public get hasDescription(): boolean {
        return this.description != null && this.description.trim() !== '';
    }

    public get dateOfLastCompletion(): Date | null {
        if (this.lastCompletion?.completedAt != null) {
            const date = new Date(this.lastCompletion?.completedAt);
            return date;
        }
        return null;
    }

    public get daysSinceLastCompletion(): number | null {
        if (this.lastCompletion?.completedAt != null) {
            const completedDate = new Date(this.lastCompletion?.completedAt);
            // Get the date of the completion, using the year, month and day
            const completedDateOnly = new Date(completedDate.getFullYear(), completedDate.getMonth(), completedDate.getDate());
            const today = new Date();
            // convert the date to locale nl
            const todayOnlyInLocaleNL = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            return this.getNumberOfDaysBetween(todayOnlyInLocaleNL, completedDateOnly);
            // return this.getNumberOfDaysBetween(today, completedDate);
        }
        return null;
    }

    public get daysUntilNextCompletion(): number | null {
        if (this.lastCompletion?.completedAt != null) {
            const completedDate = new Date(this.lastCompletion?.completedAt);
            let taskPeriodInDays = 0;
            if (this.periodType === 'DAY') {
                taskPeriodInDays = this.periodNumber;
            } else if (this.periodType === 'WEEK') {
                taskPeriodInDays = this.periodNumber * 7;
            } else if (this.periodType === 'MONTH') {
                taskPeriodInDays = this.periodNumber * 30;
            } else if (this.periodType === 'YEAR') {
                taskPeriodInDays = this.periodNumber * 365;
            }
            const nextDate = new Date(
                completedDate.getFullYear(),
                completedDate.getMonth(),
                completedDate.getDate() + taskPeriodInDays
            );
            const today = new Date();
            return this.getNumberOfDaysBetween(nextDate, today);
        }
        return null;
    }

    private getNumberOfDaysBetween(date1: Date, date2: Date): number {
        // Check if the dates are equal
        const same =            date1.getFullYear() === date2.getFullYear() &&            date1.getMonth() === date2.getMonth() &&            date1.getDate() === date2.getDate();
        if (same) {
            return 0;
        }

        const difference = date1.getTime() - date2.getTime();
        return Math.ceil(difference / (1000 * 3600 * 24));
    }
}
